import apiClient from "@/lib/apiClient";

/**
 * Fire-and-forget: tell the backend the current user opened/switched into a
 * workspace. Powers the internal staff console's per-workspace "last seen" +
 * login-count columns (workspace switching is otherwise client-side, so the
 * server never sees it). Best-effort — never throws, never blocks the UI.
 */
export function recordWorkspaceAccess(workspaceId: string | undefined): void {
  if (!workspaceId) return;
  void apiClient.post(`/workspaces/${workspaceId}/access`).catch(() => {});
}
